export const hexToRgb = (hex: string = '#000', alpha: number = 1): string => {
  if (hex === 'transparent' || hex === null) return 'rgba(0, 0, 0, 0)';

  const short = hex.length === 4;

  const r = parseInt(
    short ? `${hex.slice(1, 2)}${hex.slice(1, 2)}` : hex.slice(1, 3),
    16
  );
  const g = parseInt(
    short ? `${hex.slice(2, 3)}${hex.slice(2, 3)}` : hex.slice(3, 5),
    16
  );
  const b = parseInt(
    short ? `${hex.slice(3, 4)}${hex.slice(3, 4)}` : hex.slice(5, 7),
    16
  );
  const a = alpha > 1 ? `${alpha}%` : alpha;

  const rgba = `rgba(${r}, ${g}, ${b}${
    alpha ? `, ${a}` : ', 0'
  })`;

  return rgba;
};
